import { useEffect, useRef, useState } from 'react';
import { Box, Typography, useMediaQuery, useTheme } from '@mui/material';

import { useWeb3 } from '@/hooks/use-web3';
import {
  PoolState,
} from '@/lib/common/name-space';
import {
  PoolListType,
  ResUnStakingListType,
} from '@/types';
import PortfolioDetailTable from './table/PortfolioDetailTable';
import UnstakingModal from './modal/UnstakingModal';
import CommonButton from './CommonButton';
import { GridColDef } from '@mui/x-data-grid';
import { portfolioUnStakedDetailColumns } from './table/ColumnsData';
import PortfolioUnStakedCard from './card/PortfolioUnStakedCard';
import BigNumber from 'bignumber.js';
import { userStakingList } from '@/api/staking/read';
import { packBigNumbers } from '@/lib/BigNumbers';
import { RewardListType } from '@/types/staking/read';
import { useWeb3AuthConnect } from '@web3auth/modal/react';

export default function UnStakeList({ contractAddr, detail }: { contractAddr: string; detail: PoolListType }) {
  const [list, setList] = useState<ResUnStakingListType[] | null>(null);
  const [address, setAddress] = useState('');
  const [isOpenUnstakingModal, setIsOpenUnstakingModal] = useState(false);
  const joinId = useRef<string>('');
  //   const stakeIndex = useRef<number>(-1); // 0은 사용 가능하기에 나올 수 없는 숫자로 선언
  const [stakeIndex, setStakeIndex] = useState(-1);
  // const [detail, setDetail] = useState<ResGetPoolDetailsCall | null>(null);
  const [totalStake] = useState<string>('0');
  const { address: addr } = useWeb3();
  const { isConnected } = useWeb3AuthConnect();
  const theme = useTheme();
  const [isCanUnstake, setIsCanUnstake] = useState(true);

  // media query
  const isMobile = useMediaQuery('(max-width:900px)');

  useEffect(() => {
    (async () => {
      if (isConnected && addr) {
        setAddress(addr);
      }
    })();
    return () => {};
  }, [isConnected, addr]);
  useEffect(() => {
    if (address && contractAddr) {
      (async () => {
        const rewardListType: RewardListType = {
          address,
          poolId: detail.poolId,
        };
        const re = await userStakingList(rewardListType);
        const res = re.data.map((item: ResUnStakingListType, index: number) => ({
          ...item,
          no: index + 1,
          index,
          totStakeAmt: packBigNumbers(item.totStakeAmt),
        }));
        setList(res);
        // const cnt = await getStakeCount();
        // const re = await getStake(cnt);
        // setList(re);
        // const arrPromise = [];
        // arrPromise.push(() => web3authCall?.callStaking(STATE, contractAddr));
        // arrPromise.push(() => web3authCall?.callStaking(GETPOOLDETAILS, contractAddr));
        // arrPromise.push(() => web3authCall?.callStaking(TOTALFUNDRAISINGMULTIPLIEDPRICE, contractAddr));
        // const result = await promiseAllSettled(arrPromise);
        // setState(result[0]);
        // //setDetail(result[1]);
        // setTotalStake(result[2]);
      })();
    }

    return () => {};
  }, [address, contractAddr]);

  useEffect(() => {
    if (!detail) {
      return;
    }
    console.log(BigNumber(totalStake).lt(detail?.goalUsdt));
    // total >
    if (BigNumber(totalStake).lt(detail?.goalUsdt)) {
      setIsCanUnstake(true);
    } else {
      setIsCanUnstake(false);
    }

    return () => {};
  }, [detail, totalStake]);

  // method
  const handleOpenModal = (row: any) => {
    joinId.current = row.joinId;
    setStakeIndex(row.index);
    // 인덱스를 받아서 UnstakingModal넘겨주자
    setIsOpenUnstakingModal(true);
  };

  const addColumns: GridColDef[] = [
    ...portfolioUnStakedDetailColumns,
    // ※ 확장자 .ts에서는 renderCell을 불러올 수가 없어서 해당 기능만 추가
    {
      flex: 1,
      minWidth: 100,
      field: 'joinId',
      headerName: 'Status',
      sortable: false,
      headerAlign: 'center',
      align: 'center',
      renderCell: (params) =>
        isCanUnstake === true ? (
          <CommonButton
            sx={{ borderRadius: '5px', padding: '4px 20px', width: '80px' }}
            handleClick={() => {
              console.log(params);
              handleOpenModal(params.row);
            }}
            text="Unstake"
            // text={params.value === 'claim' ? 'Claim' : 'Unstake'}
            color="#ffffff"
            bgColor={'#357AFF'}
            variant="body2"
          />
        ) : (
          ''
        ),
    },
  ];
  return (
    <>
      <Box
        sx={{
          maxWidth: '1680px',
          padding: '16px 24px',
          marginTop: '16px',
          marginBottom: '38px',
        }}
      >
        {isMobile ? (
          <>
            {detail.state === PoolState.POOLSTATE_FUNDRAISING ? (
              <>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Unstaked Detail
                </Typography>

                <Box sx={{ display: 'flex', flexDirection: 'column', gap: '16px' }}>
                  {list &&
                    list.map((item: ResUnStakingListType, index: number) => (
                      <PortfolioUnStakedCard key={index} item={item} handleOpenModal={() => handleOpenModal(item)} />
                    ))}
                  {isCanUnstake &&
                    `● Unstacking is possible only when the Total Staked Amount is smaller than the Target Amount.`}
                </Box>
              </>
            ) : (
              ''
            )}
          </>
        ) : (
          <>
            {detail.state === PoolState.POOLSTATE_FUNDRAISING ? (
              <>
                <Typography variant="h3" color={theme.greyscale.darkgrey2} sx={{ marginBottom: '16px' }}>
                  Unstaked Detail
                </Typography>
                {list && <PortfolioDetailTable list={list} columns={addColumns} />}
                {isCanUnstake &&
                  `● Unstacking is possible only when the Total Staked Amount is smaller than the Target Amount.`}
              </>
            ) : (
              ''
            )}
          </>
        )}
      </Box>
      {stakeIndex !== -1 && detail && (
        <UnstakingModal
          open={isOpenUnstakingModal}
          handleClose={() => setIsOpenUnstakingModal(false)}
          contractAddr={contractAddr}
          joinId={joinId.current}
          detail={detail}
          stakeIndex={stakeIndex}
        />
      )}
    </>
  );
}
